'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RichText;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _renderTitle = require('shared/modules/utils/renderTitle');

var _renderTitle2 = _interopRequireDefault(_renderTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
   {
     "type": "rich_text",
     "title": "An optional title",
     "content": "..."
   }

   Displays a <div> and populates it with whatever is in
   content field. Most regular text will be this type, and
   any structured content from a WYSIWIG editor in Craft
   should probably leverage this module as well.

   An optional title attribute will display an
   appropriate <h> title.
 */

function RichText(_ref) {
  var moduleClass = _ref.moduleClass,
      title = _ref.title,
      content = _ref.content,
      style = _ref.style;

  var classNames = ['type-rich_text', moduleClass, style || ''].join(' ');
  return _react2.default.createElement(
    'div',
    {
      className: classNames
    },
    (0, _renderTitle2.default)(title),
    _react2.default.createElement('div', {
      dangerouslySetInnerHTML: {
        __html: content
      }
    })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/RichText/RichText.jsx
// module id = 1258
// module chunks = 0